import { useEffect, useState } from 'react'
import { CategoryUsage, getCategoryUsage } from '../../models/category'

export const useCategoryUsage = (categoryId?: string) => {
  const [usage, setUsage] = useState<CategoryUsage>()
  const [error, setError] = useState<Error>()

  useEffect(() => {
    // undefinedの間は前回の結果を残す（ポップアップが閉じるアニメーションの間も表示するため）
    if (categoryId === undefined) return
    setUsage(undefined)
    setError(undefined)
    // 取得中に別のカテゴリに切り替わった場合は、古い結果で上書きしないように捨てる
    let ignore = false
    getCategoryUsage(categoryId)
      .then((usage) => {
        if (!ignore) setUsage(usage)
      })
      .catch((error: Error) => {
        if (!ignore) setError(error)
      })
    return () => {
      ignore = true
    }
  }, [categoryId])

  return {
    usage,
    error,
    loading: usage === undefined && error === undefined,
  }
}
